{
  "sidebar": {
    "dashboard": "Dashboard",
    "reports": "Attendance",
    "devices": "Devices",
    "employees": "Employees",
    "entriesExits": "Entries/Exits",
    "users": "Users",
    "settings": "Settings",
    "branding": "Branding",
    "workSchedule": "Work Schedule",
    "holidays": "Holidays",
    "timeOff": "Time Off",
    "collapse": "Collapse",
    "expand": "Expand menu"
  },
  "users": {
    "title": "Users",
    "addNew": "+ New User",
    "filters": {
      "allRoles": "All roles",
      "user": "User",
      "admin": "Admin",
      "superAdmin": "Super Admin"
    },
    "filterByRole": "Filter by role",
    "failedToLoad": "Failed to load data. Please try again.",
    "empty": "No users yet.",
    "columns": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "devices": "Devices",
      "created": "Created",
      "actions": "Actions"
    },
    "actions": {
      "edit": "Edit",
      "resetPassword": "Reset pwd",
      "delete": "Delete"
    },
    "selfManageHint": "Can't manage your own account — use topbar instead",
    "confirm": {
      "delete": "Delete user {{name}}?"
    }
  },
  "schedule": {
    "title": "Work Schedule",
    "subtitle": "Define the standard working hours for your company. The break duration is automatically deducted from each employee's worked time.",
    "sectionTitle": "Working Hours",
    "shiftStart": "Work start",
    "shiftEnd": "End of work day",
    "breakMinutes": "Break",
    "minutes": "minutes",
    "breakHint": "Fixed unpaid break deducted from worked time each day.",
    "saving": "Saving…",
    "submit": "Save Schedule",
    "success": "Work schedule updated.",
    "failed": "Failed to save schedule. Please try again.",
    "lateGrace": "Late grace (minutes)",
    "lateGraceHint": "Lateness up to this many minutes is not penalized",
    "lateDeductionPercent": "Late deduction (% of hourly rate)",
    "lateDeductionHint": "Percent of the hourly rate deducted for late minutes beyond the grace period. 0 = full hourly rate (100%)",
    "lateDeductionFixed": "Use a fixed amount instead of a percent",
    "lateDeductionFixedHint": "When enabled, the fixed amount below is used instead of the percentage.",
    "lateDeductionAmount": "Fixed deduction per hour late (AMD)",
    "lateDeductionAmountHint": "Deducted for each hour of lateness beyond the grace period (e.g. 1000 → 2 h late = 2000).",
    "workingDays": "Working days",
    "workingDaysHint": "Select which days of the week are working days. At least one day must be selected.",
    "days": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "errors": {
      "invalidTime": "Enter a valid time (HH:MM).",
      "invalidBreak": "Break must be a whole number of minutes (0 or more).",
      "invalidGrace": "Enter a non-negative whole number",
      "invalidDeduction": "Enter a percent between 0 and 100",
      "invalidAmount": "Enter a non-negative amount",
      "noWorkingDays": "Select at least one working day."
    },
    "latenessSection": "Lateness rules",
    "daysPerWeek": "Working days per week (floating day off)",
    "daysPerWeekOff": "Off — use the marked days",
    "daysPerWeekHint": "E.g. 6: one unmarked day per week is automatically credited as a day off (X), with no deduction. A value on the employee card takes precedence."
  },
  "branding": {
    "title": "Branding",
    "subtitle": "These settings apply to your company's UI, PDF reports, and email notifications.",
    "logo": {
      "sectionTitle": "Company Logo",
      "upload": "Upload new logo",
      "hint": "PNG, JPG or SVG. Max 512 KB.",
      "errorType": "Only PNG, JPG and SVG files are accepted.",
      "errorSize": "File must be 512 KB or smaller.",
      "uploading": "Uploading…",
      "submit": "Upload Logo",
      "ariaCurrentLogo": "Current logo for {{name}}",
      "noLogo": "No logo uploaded yet.",
      "success": "Logo updated successfully.",
      "failed": "Logo upload failed. Please try again."
    },
    "color": {
      "sectionTitle": "Brand Color",
      "label": "Primary color",
      "ariaLabel": "Pick brand primary color",
      "saving": "Saving…",
      "submit": "Save Color",
      "success": "Brand color updated.",
      "failed": "Color update failed. Please try again."
    }
  },
  "editWebUserDialog": {
    "titleNew": "New user",
    "titleEdit": "Edit user — {{name}}",
    "nameLabel": "Name",
    "namePlaceholder": "Full name",
    "emailLabel": "Email",
    "emailPlaceholder": "user@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Min 8 characters",
    "roleLabel": "Role",
    "activeLabel": "Active",
    "cannotDeactivateSelf": "(cannot deactivate yourself)",
    "cannotChangeOwnRole": "Cannot change your own role. Use a different super admin account.",
    "saveFailed": "Save failed"
  },
  "resetWebUserPasswordDialog": {
    "title": "Reset password",
    "subtitle": "Setting a new password for {{name}}.",
    "newPasswordLabel": "New password",
    "confirmPasswordLabel": "Confirm password",
    "newPasswordPlaceholder": "Min 8 characters",
    "confirmPasswordPlaceholder": "Repeat new password",
    "errors": {
      "tooShort": "Password must be at least 8 characters.",
      "mismatch": "Passwords do not match.",
      "failed": "Reset failed. Please try again."
    },
    "submit": "Reset password",
    "submitting": "Resetting…"
  },
  "platform": {
    "pagination": {
      "of": "of",
      "previous": "Previous page",
      "next": "Next page"
    },
    "common": {
      "loading": "Loading…",
      "searchCompanies": "Search companies",
      "searchUsers": "Search users",
      "searchDevices": "Search devices",
      "filterByCompany": "Filter by company",
      "filterByRole": "Filter by role",
      "filterByStatus": "Filter by status",
      "devAbbr": "dev"
    },
    "roleBadge": "Platform Admin",
    "consoleSubtitle": "Platform Console",
    "orders": {
      "title": "Requests",
      "subtitle": "Demo booking requests submitted from the landing page",
      "empty": "No requests yet",
      "emptyHint": "Requests sent through the landing form will appear here.",
      "failedToLoad": "Failed to load requests",
      "columns": {
        "date": "Date",
        "name": "Name",
        "contacts": "Contacts",
        "company": "Company",
        "message": "Message",
        "status": "Status"
      },
      "status": {
        "all": "All",
        "new": "New",
        "contacted": "Contacted",
        "closed": "Closed"
      },
      "statusUpdated": "Status updated.",
      "statusUpdateFailed": "Failed to update status."
    },
    "companies": {
      "title": "Companies",
      "subtitle": "All tenant companies on the platform",
      "addNew": "+ New Company",
      "searchPlaceholder": "Search companies…",
      "failedToLoad": "Failed to load companies",
      "empty": "No companies yet",
      "emptyHint": "Click + New Company to onboard the first tenant.",
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "status": "Status",
        "rate": "Rate/mo",
        "employees": "Employees",
        "users": "Users",
        "devices": "Devices",
        "created": "Created",
        "actions": "Actions"
      },
      "badges": {
        "suspended": "Suspended",
        "active": "Active"
      },
      "actions": {
        "reactivating": "Reactivating…",
        "reactivate": "Reactivate",
        "suspending": "Suspending…",
        "suspend": "Suspend",
        "delete": "Delete"
      },
      "toasts": {
        "suspended": "Company suspended.",
        "reactivated": "Company reactivated.",
        "suspendFailed": "Failed to suspend company. Please try again.",
        "reactivateFailed": "Failed to reactivate company. Please try again.",
        "deleted": "Company deleted.",
        "deleteFailed": "Failed to delete company. Please try again."
      },
      "confirm": {
        "suspend": "Suspend company {{name}}? Users will be locked out.",
        "reactivate": "Reactivate company {{name}}?",
        "delete": "Delete company {{name}}? This cannot be undone from the UI."
      },
      "editAriaLabel": "Edit {{name}}",
      "deleteAriaLabel": "Delete {{name}}"
    },
    "companyEmployees": {
      "back": "Back to companies",
      "title": "{{company}} — employees",
      "titleFallback": "Company employees",
      "total": "{{count}} total",
      "searchPlaceholder": "Search by name or PIN…",
      "loadFailed": "Failed to load employees.",
      "empty": "This company has no employees yet.",
      "emptySearch": "No employees match your search.",
      "columns": {
        "name": "Employee",
        "card": "Card",
        "status": "Status",
        "hired": "Hired"
      },
      "badges": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "sync": "Sync with terminal",
      "syncing": "Syncing…",
      "syncQueued": "Queued {{commands}} command(s) on {{devices}} terminal(s). The list will refresh shortly.",
      "syncFailed": "Failed to queue the sync. Check that the company has active terminals.",
      "editDialog": {
        "title": "Edit employee",
        "subtitle": "Changes are saved in the app and pushed to the company's terminals.",
        "nameLabel": "Full name",
        "cardLabel": "Card",
        "emailLabel": "Email",
        "phoneLabel": "Phone",
        "activeLabel": "Active",
        "pinHint": "Must be unique within the company.",
        "pinTaken": "This PIN is already taken in this company.",
        "pushNotice": "The updated record will be pushed to the terminals automatically.",
        "save": "Save",
        "saving": "Saving…",
        "saved": "Employee updated and queued for push to the terminals.",
        "saveFailed": "Failed to update the employee. Please try again."
      }
    },
    "createCompanyDialog": {
      "title": "New company",
      "companyNameLabel": "Company name *",
      "slugLabel": "Slug * (auto-suggested from name)",
      "adminSectionTitle": "First admin account",
      "adminEmailLabel": "Admin email *",
      "adminNameLabel": "Admin name *",
      "adminPasswordLabel": "Admin password (leave blank to auto-generate)",
      "monthlyRateLabel": "Monthly rate (AMD)",
      "monthlyRateHelp": "Leave blank or 0 if billing is not applicable.",
      "submitting": "Creating…",
      "submit": "Create company",
      "saveFailed": "Failed to create company. Please try again.",
      "successTitle": "Company created",
      "successHint": "Share the credentials below with the new admin. The password will not be shown again.",
      "credentials": {
        "company": "Company",
        "slug": "Slug",
        "adminPassword": "Admin password"
      },
      "copyPassword": "Copy password",
      "toasts": {
        "copied": "Password copied to clipboard.",
        "copyFailed": "Could not copy to clipboard."
      },
      "slugError": "Slug must be lowercase letters, numbers, and hyphens only.",
      "namePlaceholder": "e.g. Acme Corp",
      "slugPlaceholder": "acme-corp"
    },
    "editCompanyDialog": {
      "titleEdit": "Edit company — {{name}}",
      "companyNameLabel": "Company name",
      "slugLabel": "Slug (read-only)",
      "statusHint": "Status (use Suspend / Reactivate on the list)",
      "monthlyRateLabel": "Monthly rate (AMD)",
      "monthlyRateHelp": "Leave blank or 0 if billing is not applicable.",
      "saveFailed": "Save failed. Please try again.",
      "telegramLabel": "Telegram group",
      "telegramNone": "Not connected",
      "telegramInactiveSuffix": "(bot removed)",
      "telegramHelp": "Add @SensefaceBot to the client's Telegram group — within a minute it will appear in this list.",
      "telegramLocaleLabel": "Notification language",
      "telegramTest": "Send test message",
      "telegramTesting": "Sending…",
      "telegramTestHint": "Save the changes first, then send a test.",
      "telegramTestSuccess": "Test message sent — check the group.",
      "telegramTestFailed": "Failed to send the test message."
    },
    "devices": {
      "title": "Devices",
      "subtitle": "Terminals across all companies",
      "addNew": "+ New Device",
      "searchPlaceholder": "Search serial / name…",
      "failedToLoad": "Failed to load devices",
      "empty": "No devices yet",
      "emptyHint": "Click + New Device to register the first device.",
      "filters": {
        "allCompanies": "All companies",
        "allStatuses": "All statuses",
        "active": "Active",
        "inactive": "Inactive"
      },
      "columns": {
        "serial": "Serial",
        "name": "Name",
        "company": "Company",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      },
      "badges": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "actions": {
        "edit": "Edit",
        "deactivate": "Deactivate",
        "deactivating": "Deactivating…",
        "activate": "Activate",
        "activating": "Activating…",
        "delete": "Delete"
      },
      "toasts": {
        "created": "Device created.",
        "activated": "Device activated.",
        "deactivated": "Device deactivated.",
        "toggleFailed": "Failed to update device status. Please try again.",
        "deleted": "Device deleted.",
        "deleteFailed": "Failed to delete device. Please try again.",
        "assignCompanyFirst": "Assign the device to a company (Edit) before activating it."
      },
      "confirm": {
        "deactivate": "Deactivate device {{name}}?",
        "delete": "Delete device {{name}}?"
      },
      "noCompany": "No company — assign it in Edit"
    },
    "createDeviceDialog": {
      "title": "New device",
      "companyLabel": "Company *",
      "companyPlaceholder": "Select company",
      "serialLabel": "Serial number *",
      "serialPlaceholder": "e.g. ABC123456",
      "nameLabel": "Device name *",
      "namePlaceholder": "e.g. Entrance A",
      "descriptionLabel": "Description (optional)",
      "descriptionPlaceholder": "Brief note about this device…",
      "submit": "Create device",
      "submitting": "Creating…",
      "saveFailed": "Failed to create device. Please try again."
    },
    "editDeviceDialog": {
      "title": "Edit device",
      "subtitle": "Rename the terminal, fix its serial number, or move it to another company.",
      "companyLabel": "Company *",
      "companyWarning": "Moving the terminal to another company clears its owner, drops queued commands and unlinks employees of the previous company. Attendance history stays with the previous company.",
      "serialLabel": "Serial number *",
      "serialHint": "Must match the SN reported by the terminal — otherwise it registers itself again as a pending device.",
      "nameLabel": "Device name",
      "descriptionLabel": "Description",
      "save": "Save",
      "saving": "Saving…",
      "saved": "Device updated.",
      "saveFailed": "Failed to update device. Please try again.",
      "moved": "Device moved to {{company}}."
    },
    "users": {
      "title": "Users",
      "subtitle": "Web users across all companies",
      "addNew": "+ New User",
      "searchPlaceholder": "Search name / email…",
      "failedToLoad": "Failed to load users",
      "empty": "No users yet",
      "emptyHint": "Click + New User to create the first account.",
      "filters": {
        "allCompanies": "All companies",
        "allRoles": "All roles",
        "allStatuses": "All statuses",
        "active": "Active",
        "inactive": "Inactive"
      },
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "company": "Company",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      },
      "badges": {
        "active": "Active",
        "inactive": "Inactive",
        "user": "User",
        "admin": "Admin",
        "super_admin": "Super Admin",
        "platform_admin": "Platform Admin"
      },
      "actions": {
        "deactivate": "Deactivate",
        "deactivating": "Deactivating…",
        "activate": "Activate",
        "activating": "Activating…",
        "delete": "Delete",
        "edit": "Edit"
      },
      "toasts": {
        "created": "User created.",
        "activated": "User activated.",
        "deactivated": "User deactivated.",
        "toggleFailed": "Failed to update user status. Please try again.",
        "deleted": "User deleted.",
        "deleteFailed": "Failed to delete user. Please try again."
      },
      "confirm": {
        "deactivate": "Deactivate user {{name}}?",
        "delete": "Delete user {{name}}? This cannot be undone."
      },
      "errors": {
        "cannotTogglePlatformAdmin": "Platform admin accounts cannot be deactivated.",
        "cannotToggleSelf": "You cannot deactivate your own account."
      }
    },
    "editUserDialog": {
      "title": "Edit user",
      "nameLabel": "Name",
      "roleLabel": "Role",
      "companyLabel": "Company",
      "passwordLabel": "New password",
      "passwordPlaceholder": "Leave empty to keep current",
      "passwordHint": "Minimum 8 characters. Only fill in to change it.",
      "save": "Save",
      "saving": "Saving…",
      "saved": "User updated.",
      "saveFailed": "Failed to update user. Please try again."
    },
    "createUserDialog": {
      "title": "New user",
      "companyLabel": "Company *",
      "companyPlaceholder": "Select company",
      "nameLabel": "Name *",
      "namePlaceholder": "Full name",
      "emailLabel": "Email *",
      "emailPlaceholder": "user@example.com",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Min 8 characters",
      "autoGenerateLabel": "Auto-generate password",
      "roleLabel": "Role *",
      "submit": "Create user",
      "submitting": "Creating…",
      "saveFailed": "Failed to create user. Please try again.",
      "successTitle": "User created",
      "successHint": "Share the generated password with the new user. It will not be shown again.",
      "credentials": {
        "name": "Name",
        "email": "Email",
        "password": "Generated password"
      },
      "copyPassword": "Copy password",
      "toasts": {
        "copied": "Password copied to clipboard.",
        "copyFailed": "Could not copy to clipboard."
      },
      "suspendedSuffix": " (suspended)"
    },
    "billing": {
      "title": "Billing",
      "subtitle": "Accruals, payments and outstanding balance per company",
      "searchPlaceholder": "Search companies…",
      "failedToLoad": "Failed to load billing data",
      "empty": "No companies found",
      "emptySearch": "No results match your search.",
      "columns": {
        "company": "Company",
        "rate": "Rate/mo",
        "devices": "Devices",
        "accrued": "Accrued",
        "paid": "Paid",
        "outstanding": "Outstanding",
        "lastPayment": "Last Payment",
        "actions": "Actions"
      },
      "status": {
        "credit": "credit",
        "paidInFull": "paid in full",
        "owes": "owes"
      },
      "actions": {
        "recordPayment": "Record Payment",
        "viewDetail": "View"
      },
      "recordPaymentDialog": {
        "title": "Record Payment",
        "companyLabel": "Company *",
        "companyPlaceholder": "Select company",
        "amountLabel": "Amount (AMD) *",
        "amountPlaceholder": "e.g. 12500",
        "paidAtLabel": "Date paid *",
        "noteLabel": "Note (optional)",
        "notePlaceholder": "Bank transfer ref #…",
        "submit": "Record Payment",
        "submitting": "Recording…",
        "saveFailed": "Failed to record payment. Please try again.",
        "toasts": {
          "recorded": "Payment recorded.",
          "recordFailed": "Failed to record payment."
        },
        "errors": {
          "amountTooLow": "Amount must be at least 1 AMD.",
          "dateInFuture": "Date cannot be in the future.",
          "idempotencyCollision": "This payment was already recorded."
        }
      },
      "voidPaymentDialog": {
        "title": "Void Payment",
        "message": "Void payment of {{amount}} from {{date}}? This keeps the record but excludes it from totals.",
        "reasonLabel": "Reason (optional)",
        "reasonPlaceholder": "e.g. entered in error",
        "submit": "Void Payment",
        "submitting": "Voiding…",
        "toasts": {
          "voided": "Payment voided.",
          "voidFailed": "Failed to void payment."
        }
      },
      "invoice": {
        "number": "Invoice #",
        "downloadPdf": "Download PDF",
        "emailSent": "Sent {{date}}",
        "emailPending": "Pending",
        "emailNoRecipients": "No recipients",
        "resend": "Resend",
        "resendConfirmTitle": "Resend invoice email?",
        "resendConfirmBody": "All admins of {{company}} will receive a new email with the invoice PDF.",
        "resendSuccess": "Email queued for resending",
        "resendError": "Failed to queue resend. Please try again.",
        "downloadError": "Failed to download PDF. Please try again."
      },
      "detail": {
        "backLink": "Back to Billing",
        "monthlyRate": "Monthly rate",
        "billingStarted": "Billing since",
        "noBillingStart": "Not set",
        "totalsSection": "Totals",
        "totalAccrued": "Total Accrued",
        "totalPaid": "Total Paid",
        "outstanding": "Outstanding",
        "invoicesSection": "Invoices",
        "paymentsSection": "Payments",
        "noInvoices": "No invoices yet.",
        "noPayments": "No payments yet.",
        "invoiceColumns": {
          "period": "Period",
          "devices": "Devices",
          "rate": "Rate",
          "amount": "Amount",
          "created": "Created"
        },
        "paymentColumns": {
          "datePaid": "Date Paid",
          "amount": "Amount",
          "note": "Note",
          "recordedBy": "Recorded By",
          "status": "Status",
          "actions": "Actions"
        },
        "paymentStatus": {
          "active": "Active",
          "voided": "Voided"
        },
        "voidedReason": "Void reason",
        "actions": {
          "void": "Void",
          "voided": "Voided"
        },
        "failedToLoad": "Failed to load billing detail."
      },
      "companyFields": {
        "monthlyRateLabel": "Monthly rate (AMD)",
        "monthlyRateHelp": "Leave blank or 0 if billing is not applicable."
      }
    },
    "invoices": {
      "title": "Invoices",
      "subtitle": "All issued invoices",
      "failedToLoad": "Failed to load invoices",
      "empty": "No invoices yet",
      "emptyHint": "Invoices are auto-generated on the 1st of each month",
      "emptyFiltered": "No invoices match your filters",
      "filters": {
        "allCompanies": "All companies",
        "allStatuses": "All statuses",
        "monthLabel": "Month",
        "statusLabel": "Email status",
        "companyLabel": "Company",
        "clear": "Clear"
      },
      "columns": {
        "number": "Invoice #",
        "company": "Company",
        "period": "Period",
        "devices": "Devices",
        "rate": "Rate",
        "amount": "Amount",
        "status": "Status",
        "actions": "Actions"
      },
      "status": {
        "sent": "Sent",
        "pending": "Pending",
        "noRecipients": "No recipients"
      }
    },
    "telegramChats": {
      "title": "Telegram chats",
      "subtitle": "Groups the bot has been added to — updated automatically within a minute",
      "empty": "No chats discovered yet",
      "emptyHint": "Add @SensefaceBot to a client's Telegram group and it will appear here within a minute.",
      "failedToLoad": "Failed to load chats",
      "columns": {
        "title": "Group",
        "chatId": "Chat ID",
        "status": "Status",
        "company": "Company",
        "updated": "Updated"
      },
      "statusActive": "Bot in chat",
      "statusRemoved": "Bot removed",
      "notAttached": "Not attached",
      "attachHint": "Attaching a chat to a company here enables its notifications; the language is set in Companies → Edit → Telegram.",
      "attachSuccess": "Attachment updated.",
      "attachFailed": "Failed to update the attachment.",
      "confirmReplace": "\"{{company}}\" is already attached to group \"{{chat}}\". Replace it with this group?",
      "live": "auto-updating",
      "deleteAria": "Remove chat",
      "confirmDelete": "Remove group \"{{chat}}\" from the list? If it is attached to a company, that company's notifications will be turned off.",
      "deleteSuccess": "Chat removed.",
      "deleteFailed": "Failed to remove the chat."
    },
    "nav": {
      "clients": "Clients",
      "finance": "Finance",
      "communication": "Communication"
    },
    "overview": {
      "title": "Overview",
      "subtitle": "Key numbers across the whole platform",
      "tiles": {
        "companies": "Companies",
        "companiesHint": "{{active}} active",
        "devices": "Terminals",
        "devicesHint": "connected across all companies",
        "outstanding": "Outstanding",
        "outstandingHint": "monthly rate total: {{rate}}",
        "newRequests": "New requests",
        "newRequestsHint": "from the landing page form"
      },
      "debtors": {
        "title": "Debtors",
        "empty": "Everything is paid",
        "lastPayment": "last payment:",
        "viewAll": "Open billing"
      },
      "requests": {
        "title": "Latest requests",
        "empty": "No new requests",
        "viewAll": "All requests"
      }
    }
  }
}
